import React, { Dispatch, FC, ReactNode, SetStateAction, useState } from 'react'
import styled from 'styled-components'

const StyledToggle = styled.div<{ $selected: boolean }>`
  cursor: ${({ $selected }) => ($selected ? 'auto' : 'pointer')};
  background-color: ${({ theme, $selected }) =>
    $selected ? theme.forecast.background4 : theme.forecast.background1};
  opacity: 0.8;
  padding: 8px;
  height: 28px;
  width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
  position: relative;

  &:hover {
    opacity: ${({ $selected }) => ($selected ? 0.8 : 1)};
    background-color: ${({ theme, $selected }) =>
      $selected ? theme.forecast.background4 : theme.forecast.background3};
  }
`

const SubmenuIndicator = styled.div`
  position: absolute;
  bottom: 2px;
  right: 2px;
  font-size: 6px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1;
  pointer-events: none;
`

export const ViewToggle: FC<{
  onClick: (
    selected: boolean,
    setSelected: Dispatch<SetStateAction<boolean>>
  ) => void
  children: ReactNode
  hasSubmenu?: boolean
  selected?: boolean
}> = ({ onClick, children, hasSubmenu = false, selected: selectedProp }) => {
  const [selected, setSelected] = useState(false)
  const effectiveSelected = selectedProp ?? selected

  return (
    <StyledToggle
      $selected={effectiveSelected}
      onClick={() => onClick(effectiveSelected, setSelected)}>
      {children}
      {hasSubmenu && <SubmenuIndicator>▶</SubmenuIndicator>}
    </StyledToggle>
  )
}
